import React from 'react';
import { DepthChartTab } from '../../data/sportRulesets';

interface TabNavigationProps {
  availableTabs: DepthChartTab[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
}

export const TabNavigation: React.FC<TabNavigationProps> = ({
  availableTabs,
  activeTab,
  onTabChange
}) => {
  return (
    <div className="inline-flex bg-gray-100 rounded-lg p-1 text-xs sm:text-sm">
      {availableTabs.map(tab => (
        <button
          key={tab.id}
          onClick={() => onTabChange(tab.id)}
          className={`px-2 sm:px-4 py-1 sm:py-1.5 rounded-md ${
            activeTab === tab.id 
              ? 'bg-white shadow text-primary font-medium' 
              : 'text-gray-700 hover:bg-gray-50'
          }`}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}; 